import {
  Fragment, useMemo } from "react";
  import { useTranslation } from "react-i18next";
  import {
  SendOutlined,
  EnvironmentOutlined,
  RadarChartOutlined,
  CheckCircleOutlined,
  ArrowRightOutlined,
  RightOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByKey: Record<string, JSX.Element> = {
  dispatch: <SendOutlined />,
  route: <EnvironmentOutlined />,
  track: <RadarChartOutlined />,
  pod: <CheckCircleOutlined />,
};

interface WorkflowFlowProps {
  className?: string;
  variant?: "default" | "compact";
}

const WorkflowFlow = ({ className = "", variant = "default" }: WorkflowFlowProps) => {
  const { t } = useTranslation("tms");
  const isCompact = variant === "compact";

  const steps = useMemo(() => {
    const raw = t("workflow.steps", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ key: string; label: string }>;
  }, [t]);

  return (
    <div
      className={[
        "dev-tms-workflow-grid",
        isCompact ? "dev-tms-workflow--compact" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="dev-tms-workflow-track">
        {steps.map((step, idx) => (
          <Fragment key={step.key}>
            {isCompact ? (
              <div className="dev-tms-step-item">
                <div className={`dev-tms-step-card dev-tms-step-card--${step.key}`}>
                  <div className="dev-tms-step-icon">{iconByKey[step.key] ?? <RightOutlined />}</div>
                </div>
                <div className="dev-tms-step-title">{step.label}</div>
              </div>
            ) : (
              <div className={`dev-tms-step-card dev-tms-step-card--${step.key}`}>
                <div className="dev-tms-step-icon">{iconByKey[step.key] ?? <RightOutlined />}</div>
                <div className="dev-tms-step-title">{step.label}</div>
              </div>
            )}
            {idx < steps.length - 1 && (
              <div className="dev-tms-step-connector" aria-hidden>
                <ArrowRightOutlined />
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default WorkflowFlow;
